<bootstrap-popup [id]="id" [title]="'Signataires'" [displaySubject]="displaySubject" [windowCloseButton]="true" (closed)="onClosed()">
	<form class="form-horizontal" role="form">
	    <div class="row" #container>
	        <div class="form-group col-sm-12">
	            <filtered-drag-drop-groups
	                    [parentContainer] = "container"
	                    [containerClass] = "'col-sm-6'"
	                    [listClass] = "'signatairesList'"
	                    [leftTitle] = "'Non-li&eacute;s'" [leftList] = "signatairesNonLies"
	                    [rightTitle] = "'Li&eacute;s'" [rightList] = "signatairesLies"
	                    [labelGetter] = "getIntervenantLabel">
	            </filtered-drag-drop-groups>
	        </div>
	    </div>
	
	    <div class="form-group">
	    	<div class="col-md-12 text-center">
				<button class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
	        	<button class="btn btn-primary" (click)="save()">Valider</button>
	        </div>
	    </div>
	</form>
</bootstrap-popup>